import { Badge, HStack, Box, Text } from '@chakra-ui/react';
import { FiShield } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import type { Steward } from '../../types/union'

export function StewardBadge({ steward, onRemove }: {
  steward: Steward
  onRemove?: () => void
}) {
  const navigate = useNavigate()
  return (
    <Badge
      px={2} py={0.5} borderRadius="full" fontSize="xs"
      colorPalette="teal" variant="subtle" cursor="pointer"
      onClick={(e) => { e.stopPropagation(); if (steward.contactId) navigate(`/dashboard/contacts/${steward.contactId}`) }}
      _hover={{ opacity: 0.8 }}
    >
      <HStack gap={1}>
        <Box boxSize={3} asChild><FiShield /></Box>
        <Text>{steward.contactName || steward.name}</Text>
        {steward.role && <Text color="teal.600">({steward.role})</Text>}
        {onRemove && (
          <Text
            ml={1} color="red.500" fontWeight="bold" cursor="pointer"
            onClick={(e) => { e.stopPropagation(); onRemove() }}
          >
            ×
          </Text>
        )}
      </HStack>
    </Badge>
  );
}
